import { render, staticRenderFns } from "./add_tz.vue?vue&type=template&id=361576bc&"
import script from "./add_tz.vue?vue&type=script&lang=js&"
export * from "./add_tz.vue?vue&type=script&lang=js&"
import style0 from "./add_tz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports